<script lang="ts">
    import { browser } from "$app/environment";
    import { page } from "$app/stores";
    import Share from "$lib/components/episodes/Share.svelte";
    import { colors, activeColor, focusContent } from "$lib/data";
    import { get_pattern } from "$lib/utilities";

    export let guest_host: boolean = false;
    export let episodeNumber: number;
    export let guests: number;
    export let galleryCount: number;
    export let achievementCount: number;
    export let videoCount: number;
    export let bonusCount: number;
    export let in_revue: string = "";

    let link_text: string = "Episode Archive";

    $: base = `/episodes/episode-${episodeNumber}`;
    let y: number;
    let firstLink: HTMLElement;
    $: if ($focusContent && browser) firstLink.focus();
</script>

<svelte:window bind:scrollY={y} />
<aside
    style="
        --primary: {colors[$activeColor].color};
        --secondary: {colors[$activeColor].highlight};
    "
>
    <div
        class="header"
        class:bottomfix={$page.url.pathname == base}
        style:background-image={get_pattern()}
    >
        <a
            class:disable={episodeNumber === 1}
            href="/episodes/episode-{episodeNumber - 1}/"
            data-sveltekit-preload-data
            on:mouseenter={() => (link_text = "Previous Episode")}
            on:mouseleave={() => (link_text = "Episode Archive")}
        >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"
                ><rect width="256" height="256" fill="none" /><polygon
                    points="120 32 24 128 120 224 120 176 184 176 184 80 120 80 120 32"
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="16"
                /><line
                    x1="216"
                    y1="176"
                    x2="216"
                    y2="80"
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="16"
                /></svg
            >
        </a>
        <a
            bind:this={firstLink}
            href="/episodes/"
            class="middle"
            class:right_missing={episodeNumber === $page.data.stats.total_episodes}
            class:left_missing={episodeNumber === 1}
            data-sveltekit-preload-datacount
        >
            <span>{link_text}</span>
        </a>
        <a
            href="/episodes/episode-{episodeNumber + 1}/"
            data-sveltekit-preload-data
            on:mouseenter={() => (link_text = "Next Episode")}
            on:mouseleave={() => (link_text = "Episode Archive")}
            class:disable={episodeNumber === $page.data.stats.total_episodes}
        >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"
                ><rect width="256" height="256" fill="none" /><polygon
                    points="136 32 232 128 136 224 136 176 72 176 72 80 136 80 136 32"
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="16"
                /><line
                    x1="40"
                    y1="176"
                    x2="40"
                    y2="80"
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="16"
                /></svg
            >
        </a>
    </div>
    <div class="sticker">
        <nav>
            <a
                href={base}
                class:active={$page.url.pathname == base}
                data-sveltekit-preload-data
            >
                <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    ><path
                        d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z"
                    /><polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02" /></svg
                >
                {#if y > 400}
                    Episode #{episodeNumber}
                {:else}
                    The Episode
                {/if}
            </a>
            {#if guests > 0}
                <a
                    href="{base}/guests"
                    class:active={$page.url.pathname == base + "/guests"}
                    data-sveltekit-preload-data
                    data-sveltekit-noscroll
                >
                    {#if guests > 1 || guest_host}
                        <svg
                            class="adjuster"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            ><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle
                                cx="9"
                                cy="7"
                                r="4"
                            /><path d="M23 21v-2a4 4 0 0 0-3-3.87" /><path
                                d="M16 3.13a4 4 0 0 1 0 7.75"
                            /></svg
                        >
                        The Guests
                    {:else}
                        <svg
                            class="adjuster"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            ><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle
                                cx="12"
                                cy="7"
                                r="4"
                            /></svg
                        >
                        The Guest
                    {/if}
                </a>
            {/if}
            <a
                href="{base}/gallery"
                class:active={$page.url.pathname == base + "/gallery"}
                data-sveltekit-preload-data
                data-sveltekit-noscroll
            >
                <svg
                    class="adjuster"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    ><rect x="3" y="3" width="18" height="18" rx="2" ry="2" /><circle
                        cx="8.5"
                        cy="8.5"
                        r="1.5"
                    /><polyline points="21 15 16 10 5 21" /></svg
                >
                Contribution Gallery
                {#if galleryCount > 0}
                    <span class="count">
                        {galleryCount}
                    </span>
                {/if}
            </a>
            <a
                href="{base}/process-videos"
                class:active={$page.url.pathname == base + "/process-videos"}
                data-sveltekit-preload-data
                data-sveltekit-noscroll
            >
                <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    ><polygon points="23 7 16 12 23 17 23 7" /><rect
                        x="1"
                        y="5"
                        width="15"
                        height="14"
                        rx="2"
                        ry="2"
                    /></svg
                >
                Process Videos
                {#if videoCount > 0}
                    <span class="count">
                        {videoCount}
                    </span>
                {/if}
            </a>
            {#if in_revue !== ""}
                <a
                    href="{base}/in-revue"
                    class:active={$page.url.pathname == base + "/in-revue"}
                    data-sveltekit-preload-data
                >
                    <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        ><path
                            d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z"
                        /><polygon
                            points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02"
                        /></svg
                    >
                    In Revue
                </a>
            {/if}
            {#if episodeNumber > 106}
                <a
                    href="{base}/achievements"
                    class:active={$page.url.pathname == base + "/achievements"}
                    data-sveltekit-preload-data
                    data-sveltekit-noscroll
                >
                    <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        ><circle cx="12" cy="8" r="7" /><polyline
                            points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"
                        /></svg
                    >
                    Achievements
                    {#if achievementCount > 0}
                        <span class="count">
                            {achievementCount}
                        </span>
                    {/if}
                </a>
            {/if}
            <a
                href="{base}/bonus"
                class:active={$page.url.pathname == base + "/bonus"}
                data-sveltekit-preload-data
            >
                <svg
                    class="adjuster"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    ><rect x="3" y="3" width="18" height="18" rx="2" ry="2" /><circle
                        cx="8.5"
                        cy="8.5"
                        r="1.5"
                    /><polyline points="21 15 16 10 5 21" /></svg
                >
                Bonus Gallery
                {#if bonusCount > 0}
                    <span class="count">
                        {bonusCount}
                    </span>
                {/if}
            </a>
        </nav>

        <Share episode={episodeNumber} />
    </div>
</aside>

<style>
aside {
  width: 27%;
  margin-right: 2rem;
  background: white;
  box-shadow: 0px 0px 5.3px rgba(100, 122, 139, 0.07), 0px 0px 17.9px rgba(100, 122, 139, 0.044), 0px 0px 80px rgba(215, 237, 255, 0.5);
  border-radius: 2rem;
  font-weight: bold;
}
aside .sticker {
  position: sticky;
  top: 70px;
}
aside .header {
  border-radius: 2rem 2rem 0 0;
  overflow: hidden;
  display: flex;
}
aside .header a {
  border: none;
  background: transparent;
  border-bottom: 1px solid var(--dots);
  display: flex;
  padding: 1rem 1.5rem;
  cursor: pointer;
  flex-flow: row;
  text-decoration: none;
  align-items: center;
  justify-content: center;
  color: var(--blue);
  font-size: 0.75rem;
  text-transform: uppercase;
  font-family: "Open Sans";
}
aside .header a.disable {
  pointer-events: none;
}
aside .header a.disable svg {
  opacity: 0.2;
}
aside .header a.middle {
  flex-grow: 1rem;
  width: 100%;
  border-left: 1px solid var(--dots);
  border-right: 1px solid var(--dots);
}
aside .header a.middle span {
  padding-top: 0.1rem;
  color: var(--offDark);
}
aside .header a:hover svg, aside .header a:focus svg {
  fill: var(--primary);
}
aside .header a svg {
  width: 1.2rem;
  height: 1.2rem;
  fill: var(--secondary);
  place-self: center;
}
aside .header a span {
  position: relative;
  top: 1px;
}
aside .header.bottomfix a {
  border-bottom: 1px solid transparent;
}
aside nav a {
  font-size: 0.9rem;
  border: none;
  background: transparent;
  display: flex;
  padding: 0.75rem 1rem;
  cursor: pointer;
  flex-flow: row;
  text-decoration: none;
  align-items: center;
  color: var(--title);
  position: relative;
  font-family: "Open Sans";
  border-bottom: 1px solid var(--dots);
}
aside nav a .count {
  position: absolute;
  right: 1rem;
  font-size: 0.75rem;
  font-family: "Open Sans", sans-serif;
  display: grid;
  place-content: center;
  padding: 0.5rem;
  border-radius: 0.5rem;
  color: var(--offDark);
}
aside nav a:hover {
  color: var(--primary);
}
aside nav a:hover svg {
  stroke: var(--primary);
}
aside nav a.active {
  background: radial-gradient(circle, rgb(220, 234, 240) 0%, rgb(240, 245, 247) 100%);
}
aside nav a svg {
  margin: 0 1.2rem 0 0.75rem;
  width: 1.2rem;
  height: 1.2rem;
  stroke: var(--secondary);
}
</style>
